import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  FormControl,
} from "@mui/material";
import ApiService from "../../ApiService";

import { Alert } from "@mui/material";
import { Grid } from "@material-ui/core";

const useStyles = (theme) => ({
  searchbar: {
    margin: theme.spacing(2),
  },
  formControl: {
    minWidth: 200,
  },
});

class CopyMerchants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: "",
      failed: false,
      success: false,
      responsemessage: "",
      merchants: [],
    };
    this.handleChange = this.handleChange.bind(this);

    this.loadMerchants = this.loadMerchants.bind(this);
    this.copyUserMenuAccess = this.copyUserMenuAccess.bind(this);
  }

  componentDidMount() {
    this.loadMerchants();
  }

  loadMerchants() {
    ApiService.fetchOtherMerchants(this.props.user[0].id).then((res) => {
      this.setState({ merchants: res.data });
    });
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  copyUserMenuAccess() {
    ApiService.copyUserMenuAccess(
      this.state.selectedValue,
      this.props.user[0].id
    )
      .then((res) => {
        if (res.data.status == "OK") {
          this.setState({
            failed: false,
            success: true,
            responseMessage: res.data.responseMessage,
          });
          setTimeout(() => this.props.hideCopyPanel(), 1000);
          this.props.reloadUserAccess();
        } else {
          this.setState({
            failed: true,
            success: false,
            responseMessage: res.data.responseMessage,
          });
        }
      })
      .catch((err) => {
        this.setState({ failed: true, success: false, responseMessage: err });
      });
  }

  render() {
    const { classes } = this.props;

    return (
      <>
        {this.state.failed && (
          <Alert severity="error" elevation="0">
            Failed
            {this.state.responsemessage}
          </Alert>
        )}
        {this.state.success && (
          <Alert severity="success" elevation="0">
            success
            {this.state.responsemessage}
          </Alert>
        )}

        <Grid xs={12} container>
          <Grid xs={8} item sx={{ marginRight: "5px" }}>
            <FormControl className={classes.formControl} fullWidth>
              <InputLabel id="menuSelectLabel">Users</InputLabel>
              <Select
                value={this.state.selectedValue}
                onChange={this.handleChange}
                name="selectedValue"
                label="selectedValue"
                id="selectedValue"
              >
                {this.state.merchants &&
                  this.state.merchants.map((m) => (
                    <MenuItem key={m.id} value={m.id} dense>
                      {m.userName}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <Box align="center">
              <Button
                variant="contained"
                className={classes.searchbar}
                color="primary"
                size="small"
                onClick={this.copyUserMenuAccess}
                style={{ display: "inline-block", marginLeft: "400px" }}
              >
                Ok
              </Button>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  }
}

export default withStyles(useStyles)(CopyMerchants);
